/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDto } from '../../models/user-dto';
import { UserPhoneSignInDto } from '../../models/user-phone-sign-in-dto';

export interface UserControllerPhoneLogin$Params {
      body: UserPhoneSignInDto
}

export function userControllerPhoneLogin(http: HttpClient, rootUrl: string, params: UserControllerPhoneLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
'user'?: UserDto;
}>> {
  const rb = new RequestBuilder(rootUrl, userControllerPhoneLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'accessToken'?: string;
      'refreshToken'?: string;
      'user'?: UserDto;
      }>;
    })
  );
}

userControllerPhoneLogin.PATH = '/api/user/signin/phone';
